<template>
    <section class="export-product-brands-index">
        <div class="col-md-12">
            <pim-header header="Export Brands"></pim-header>
            <div>
                <product-alerts :status="alert" v-model="alert"></product-alerts>
            </div>

            <transition name="vue-table-loader">
                <div class="vue-table-loader" v-if="isLoading"><span class="fa fa-cog fa-spin fa-3x"></span></div>
            </transition>

            <div class="card panel panel-default">
                <div class="card-block">
                    <form action="">
                        <input type="hidden" name="_token" :value="csrfToken">
                        <div class="row">
                            <div class="col-md-8">
                                <label for="" v-if="selectField.label">
                                    <span class="label-title">{{selectField.label}}</span>
                                    <span v-if="selectField.required" class="required-field">*</span>
                                </label>
                                <input-selectbox v-model="selectField.value" :field-data="selectField"></input-selectbox>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <button v-on:click="exportBrands()" type="button" class="btn btn-primary">Export</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </section>
</template>

<script type="text/javascript">
    var base_url = window.location.protocol + "//" + window.location.host

    import Vue from 'vue';
    import VueEvents from 'vue-events';
    import axios from 'axios';

    import PimHeader from '../generic/pim-header';
    import InputSelectbox from '../form/form-selectbox.vue';
    import ProductAlerts from '../products/product-details-alerts.vue';

    Vue.use(VueEvents)

    export default {
        name: 'export-product-brands-index',
        props: ['csrfToken'],
        components: {
            'pim-header': PimHeader,
            'input-selectbox': InputSelectbox,
            'product-alerts': ProductAlerts,
        },
        data() {
            return {
                selectField: {
                    label: 'Select the Version to export',
                    required: true,
                    disabled: false,
                    type: 'select',
                    name: 'selectedEntity',
                    value: '',
                    options: dataObject.versions
                },
                isLoading: false,
                alert: {
                    message: "",
                    status: "alert-success",
                    timeOut: 15000,
                },
            }
        },
        methods: {
            exportBrands: function () {
                if (!this.selectField.value) {
                    this.alert.status = "alert-danger";
                    this.alert.message = 'Please, first select a version to export';
                    return;
                }

                this.isLoading = true;

                axios.post(base_url + '/export-product-brands', {
                    'versionId': this.selectField.value,
                })
                .then(function() {
                    this.alert.status = "alert-success";
                    this.alert.message = 'Success, export initiated, we are redirecting you to the Jobs page.';
                    setTimeout(function() {
                        window.location = "/jobs";
                    }, 2000);
                }.bind(this))
                .catch(function (error) {
                    this.alert.status = "alert-danger";
                    this.alert.message = error.response.data.message || 'There was an error, please try again later.';
                }.bind(this))
                .finally(function() {
                    this.isLoading = false;
                }.bind(this));
            },
        }
    };
</script>
